import { render, staticRenderFns } from "./ClientsEditComponent.vue?vue&type=template&id=9f99fa8c"
import script from "./ClientsEditComponent.vue?vue&type=script&lang=js"
export * from "./ClientsEditComponent.vue?vue&type=script&lang=js"
import style0 from "./ClientsEditComponent.vue?vue&type=style&index=0&id=9f99fa8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports